import { CategoriesApi } from "../api/CategoriesApi";
import { ConfigApi } from "../api/ConfigApi";
import { ProductApi } from "../api/ProductApi";
import { TemplateApi } from "../api/TemplateApi";
import { Home } from "../pages/Home";
import { initServerSession } from "../utilities/sessionContext";

export async function loader({ request }) {
	// Initialize session for data requests during client navigation
	initServerSession(request);
	const bannerCarouselPromise = ConfigApi.GetConfig(request)
		.then(({ current_peak_id }) => TemplateApi.getBannerCarousel(current_peak_id))
		.then(({ banner_carousel }) => banner_carousel ?? [])
		.catch((error) => {
			console.warn("SSR prefetch homepage banners failed", error);
			return [];
		});

	try {
		const { content_blocks, meta } = await CategoriesApi.getContentBlocks();
		let prefetchedProducts = [];
		try {
			const productIds = (content_blocks || []).reduce((acc, block) => {
				if (!Array.isArray(block)) return acc;
				block.forEach((p) => {
					if (p?.products_id) acc.push(p.products_id);
				});
				return acc;
			}, []);
			if (productIds.length) {
				const { products } = await ProductApi.getInfoBulk(productIds);
				const productMap = new Map(Object.values(products).map((p) => [p.products_id || p.id, p]));
				prefetchedProducts = (content_blocks || []).map((block) => {
					if (!Array.isArray(block)) return [];
					return block
						.map((item) => {
							const id = item?.products_id;
							return id ? productMap.get(id) || item : item;
						})
						.filter(Boolean);
				});
			}
		} catch (prefetchErr) {
			console.warn("SSR prefetch homepage products failed", prefetchErr);
			prefetchedProducts = [];
		}

		return {
			homepageInfo: content_blocks ?? [],
			meta: meta ?? null,
			prefetchedProducts,
			bannerCarousel: await bannerCarouselPromise,
		};
	} catch (error) {
		console.warn("SSR prefetch homepage failed", error);
		return { homepageInfo: [], meta: null, prefetchedProducts: [], bannerCarousel: await bannerCarouselPromise };
	}
}

export default function HomeRoute() {
	return <Home />;
}
